import axios from "axios";
import { BASE_URL } from "../config/api_collection";

const GENERATE_TOKEN = `${BASE_URL}/api/ibe/token`;

// function to get the token that needs to be passed for all the api's
export function getToken(isNew: boolean = false) {
  const tokenApiUrl = GENERATE_TOKEN;
  const requestBody = { clientType: "WEB" };

  let isTokenExpired = true;
  const storedToken = localStorage.getItem("token");
  // to check weather the token is expired or not
  if (!isNew) {
    const tokenGeneratedTime = localStorage.getItem("tokenGeneratedTime");
    const idleTimeoutInMinutes = localStorage.getItem("tokenIdleTimeout")
    if (tokenGeneratedTime && idleTimeoutInMinutes) {
      const timeDiff = Date.now() - parseInt(tokenGeneratedTime, 10);
      // Keep 1 min buffer between token expiry. Round up to mins so 3.5 mins will be treated as 4 mins
      if (Math.ceil(timeDiff / 60000) >= (parseInt(idleTimeoutInMinutes, 10) - 1)) {
        isTokenExpired = true;
      } else {
        isTokenExpired = false;
        localStorage.setItem("tokenGeneratedTime", Date.now().toString()); // if token is not expired, reset the timer
      }
    } else {
      isTokenExpired = true;
    }
  }

  // if only token is expired, get a new token, else, use the same token.
  if (isTokenExpired) {
    try {
      const token = axios
        .post(tokenApiUrl, requestBody)
        .then((res) => {
          const tokenHeaders: any = {
            Authorization: res.data.data.token
          };
          localStorage.setItem("token", res.data.data.token);
          localStorage.setItem("tokenGeneratedTime", Date.now().toString());
          localStorage.setItem("tokenIdleTimeout", res.data.data.idleTimeoutInMinutes);
          return tokenHeaders;
        })
        .catch((err) => ({
          Authorization: "",
          error: err
        }));
      return token;
    } catch (err) {
      return {
        Authorization: "",
        error: err
      };
    }
  } else {
    return {
      Authorization: storedToken
    };
  }
}

export function getSessionToken() {
  try {
    const storedToken = sessionStorage.getItem("auth-access-token");

    if (storedToken) {
      return `Bearer ${storedToken}`;
    }

    return null;
  } catch (error) {
    console.warn("error in getting the session token", error);
    return null;
  }
}
